import React from 'react';

import { useMatchMedia } from '@betterment/js-runtime';
import { Box, Card, H2, Separator, Tag, Text } from '@betterment/samba-react';
import { useFeatureFlag } from '@betterment/shared-components';

import { useReferralSenderOffer } from './ReferAFriendProvider';

import { getReferralSenderOffer } from '../utils';

const UnclaimedRewardCard: React.FC = () => {
  const { enabled: isCashReserveApyUpdateQ32025Enabled, loading: isFeatureFlagLoading } = useFeatureFlag({
    splitName: 'retail.refer_a_friend_rewards_card_updated_rate_q3_2025_enabled',
    context: 'UnclaimedRewardCard',
  });

  const { senderOfferName, hasMaximumInvestingReferrals } = useReferralSenderOffer();
  const isAtLeastMedium = useMatchMedia('atLeastMedium');

  if (senderOfferName == null || hasMaximumInvestingReferrals) return null;
  const { title, titleV2, description, additionalDescription, limitedTime, featuredImage } =
    getReferralSenderOffer(senderOfferName);

  return (
    <Card css={{ p: 'space.400' }}>
      <Card.Header>
        <H2 variant="title200">Your next referral reward</H2>
      </Card.Header>
      <Box css={{ py: 'space.300' }}>
        <Separator />
      </Box>
      <Card.Content>
        <div>
          <Box
            css={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: { base: 'column', sm: 'row' },
              gap: { base: 'space.200', sm: 'space.400' },
            }}
          >
            <Box css={{ maxWidth: { base: 'none', md: '100px' }, width: '100%', margin: '0 auto' }}>
              {isAtLeastMedium ? (
                <img src={featuredImage.image} alt={featuredImage.alt} width="100%" />
              ) : (
                <img src={featuredImage.mobile} alt={featuredImage.alt} width="100%" />
              )}
            </Box>

            <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: 'space.50' }}>
              {limitedTime && <Tag accent="blue">Limited Time</Tag>}
              {!isFeatureFlagLoading && (
                <Text
                  as="p"
                  css={{
                    fontWeight: 'medium',
                    marginBottom: 'space.100',
                  }}
                >
                  {isCashReserveApyUpdateQ32025Enabled && titleV2 ? titleV2 : title}
                </Text>
              )}
              <Text as="p" color="text.weak" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
                {description} {additionalDescription}
              </Text>
            </Box>
          </Box>
        </div>
      </Card.Content>
    </Card>
  );
};

export default UnclaimedRewardCard;
